import { jsPDF } from 'jspdf';

// A quitação inferida por parcelas não substitui a confirmação da inscrição.
export const buildConfirmedStudentLists = (event, enrollments = [], byClassroom = false) => {
  const confirmed = enrollments.filter((item) => item.status === 'CONFIRMED');
  const sortNames = (names) => names.sort((a, b) => a.localeCompare(b, 'pt-BR'));
  if (!byClassroom) return [{ title: '', names: sortNames(confirmed.map((item) => item.studentNameSnapshot || 'Nome não informado')) }];
  const groups = new Map();
  confirmed.forEach((item) => {
    const key = String(item.classroomExternalIdSnapshot || 'SEM_TURMA');
    if (!groups.has(key)) {
      const classroom = event?.classrooms?.find((row) => String(row.classroomExternalId) === key);
      groups.set(key, {
        title: item.classroomNameSnapshot || classroom?.classroomNameSnapshot || 'Turma não informada',
        names: [],
      });
    }
    groups.get(key).names.push(item.studentNameSnapshot || 'Nome não informado');
  });
  return Array.from(groups.values()).sort((a, b) => a.title.localeCompare(b.title, 'pt-BR'))
    .map((group) => ({ ...group, names: sortNames(group.names) }));
};

export const createConfirmedStudentsPdf = (event, enrollments, byClassroom = false) => {
  const groups = buildConfirmedStudentLists(event, enrollments, byClassroom);
  if (!groups.some((group) => group.names.length)) return null;
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  const margin = 16;
  const width = doc.internal.pageSize.getWidth() - margin * 2;
  const bottom = doc.internal.pageSize.getHeight() - margin;
  let y = margin;
  let studentNumber = 0;
  const totalStudents = groups.reduce((sum, group) => sum + group.names.length, 0);
  const header = (title, count) => {
    doc.setTextColor(30, 55, 70);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(13);
    const lines = doc.splitTextToSize(title, width);
    doc.text(lines, margin, y);
    y += lines.length * 6;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(90);
    doc.text(`${count} aluno(s) confirmado(s)`, margin, y);
    doc.setDrawColor(205, 215, 220);
    doc.setLineWidth(0.2);
    doc.line(margin, y + 2, margin + width, y + 2);
    y += 6;
    doc.setTextColor(35);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(11);
  };
  groups.forEach((group, index) => {
    const title = byClassroom ? group.title : 'Lista geral';
    if (index) y += 6;
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(13);
    const headerHeight = doc.splitTextToSize(title, width).length * 6 + 6;
    // Não deixar o título da turma sozinho no fim da folha.
    if (y + headerHeight + 5 > bottom) { doc.addPage(); y = margin; }
    header(title, group.names.length);
    group.names.forEach((name) => {
      studentNumber += 1;
      const numberWidth = Math.max(10, doc.getTextWidth(`${totalStudents}.`) + 4);
      const lines = doc.splitTextToSize(String(name).replace(/\s+/g, ' ').trim(), width - numberWidth);
      lines.forEach((line, lineIndex) => {
        if (y + 5 > bottom) { doc.addPage(); y = margin; header(title, group.names.length); }
        if (lineIndex === 0) {
          doc.setTextColor(100);
          doc.text(`${studentNumber}.`, margin + numberWidth - 3, y, { align: 'right' });
          doc.setTextColor(35);
        }
        doc.text(line, margin + numberWidth, y);
        y += 5;
        if (lineIndex === lines.length - 1) y += 2;
      });
    });
  });
  if (y + 10 > bottom) { doc.addPage(); y = margin; }
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.setTextColor(30, 55, 70);
  doc.text(`Total geral: ${totalStudents} aluno(s) confirmado(s)`, margin, y + 5);
  const pageCount = doc.getNumberOfPages();
  for (let page = 1; page <= pageCount; page += 1) {
    doc.setPage(page);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(110);
    doc.text(`Página ${page} de ${pageCount}`, margin + width, bottom + 8, { align: 'right' });
  }
  return doc;
};

export const downloadConfirmedStudentsPdf = (event, enrollments, byClassroom = false) => {
  const doc = createConfirmedStudentsPdf(event, enrollments, byClassroom);
  if (!doc) return;
  const eventName = String(event?.name || event?.id || 'evento').normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/gi, '-').toLowerCase();
  doc.save(`${eventName}-confirmados-${byClassroom ? 'por-turma' : 'geral'}.pdf`);
};
